import { Suspense, type ReactNode } from "react";
import { ErrorBoundary, type FallbackProps } from "react-error-boundary";

function DefaultError({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="flex flex-col items-center gap-2 py-6 text-sm text-muted-foreground">
      <p>Yüklenirken hata oluştu.</p>
      <button
        type="button"
        onClick={resetErrorBoundary}
        className="text-xs underline underline-offset-2 hover:text-foreground"
      >
        Tekrar dene
      </button>
    </div>
  );
}

interface AsyncSectionProps {
  /** Yükleme sırasında gösterilecek skeleton bileşeni — zorunlu */
  fallback: ReactNode;
  /** Hata durumunda gösterilecek UI. Verilmezse DefaultError kullanılır. */
  errorFallback?: ReactNode;
  children: ReactNode;
}

export function AsyncSection({ fallback, errorFallback, children }: AsyncSectionProps) {
  return (
    <ErrorBoundary
      fallbackRender={(props) =>
        errorFallback ? <>{errorFallback}</> : <DefaultError {...props} />
      }
    >
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  );
}
